import { Injectable, computed, signal } from '@angular/core';

import { AuthStatus, CurrentUser } from './auth.model';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private readonly statusState = signal<AuthStatus>('unknown');
  private readonly userState = signal<CurrentUser | null>(null);

  readonly status = this.statusState.asReadonly();
  readonly user = this.userState.asReadonly();

  readonly authenticated = computed(
    () => this.statusState() === 'authenticated' && this.userState() !== null,
  );

  setAuthenticated(user: CurrentUser): void {
    this.userState.set(user);
    this.statusState.set('authenticated');
  }

  setAnonymous(): void {
    this.userState.set(null);
    this.statusState.set('anonymous');
  }

  reset(): void {
    this.userState.set(null);
    this.statusState.set('unknown');
  }

  hasPermission(permission: string): boolean {
    return this.userState()?.permissoes.includes(permission) ?? false;
  }

  hasAnyPermission(permissions: string[]): boolean {
    return permissions.some(
      (permission) => this.hasPermission(permission),
    );
  }
}
